export default function getMonthsFromPackages(packages) {
    const months = [];
    for(let i = 0, l = packages.length; i < l; ++i) {
        months.push(new Date(packages[i].month));
    }

    return months;
}